import CrudModel from './CrudModel';
import { normalizeDecimalValue } from 'utils/decimal';

export default class CompanyDiscountsModel extends CrudModel {
    constructor(entity) {
        super(entity);
        this.entity.discount1 = this.normalizeNumber(this.entity.discount1);
        this.entity.discount2 = this.normalizeNumber(this.entity.discount2);
        this.entity.discount3 = this.normalizeNumber(this.entity.discount3);
        this.entity.discount4 = this.normalizeNumber(this.entity.discount4);
    }

    static fromAdd(companyId, familyId) {
        const object = {
            companyId,
            familyId,
            discount1: 0,
            discount2: 0,
            discount3: 0,
            discount4: 0,
        };
        return object;
    }

    toMap() {
        const obj = { ...this.entity };
        obj.discount1 = this.discount1;
        obj.discount2 = this.discount2;
        obj.discount3 = this.discount3;
        obj.discount4 = this.discount4;
        obj.totalDiscount = this.totalDiscount;
        return obj;
    }

    get saveUpdate() {
        const entity = this.entity;
        const entityUpdate = {
            id: entity.id,
            discount1: this.normalizeNumber(entity.discount1),
            discount2: this.normalizeNumber(entity.discount2),
            discount3: this.normalizeNumber(entity.discount3),
            discount4: this.normalizeNumber(entity.discount4),
        };
        return entityUpdate;
    }

    get id() {
        return this.entity.id;
    }

    get familyId() {
        return this.entity.familyid;
    }

    get familyName() {
        return this.entity.familyname;
    }

    get companyId() {
        return this.entity.companyid;
    }

    get companyName() {
        return this.entity.companyname;
    }

    get discount1() {
        return this.entity.discount1 ? this.entity.discount1.toString() : '0';
    }

    set discount1(str) {
        this.entity.discount1 = this.normalizeNumber(str);
    }

    get discount2() {
        return this.entity.discount2 ? this.entity.discount2.toString() : '0';
    }

    set discount2(str) {
        this.entity.discount2 = this.normalizeNumber(str);
    }

    get discount3() {
        return this.entity.discount3 ? this.entity.discount3.toString() : '0';
    }

    set discount3(str) {
        this.entity.discount3 = this.normalizeNumber(str);
    }

    get discount4() {
        return this.entity.discount4 ? this.entity.discount4.toString() : '0';
    }

    set discount4(str) {
        this.entity.discount4 = this.normalizeNumber(str);
    }

    get totalDiscount() {
        let totalDiscount = 1;
        for (let i = 1; i <= 4; i++) {
            totalDiscount *= 1 - Number(this.normalizeNumber(this.entity[`discount${i}`])) / 100;
        }
        return Number((1 - totalDiscount) * 100);
    }

    normalizeNumber(value) {
        const normalized = normalizeDecimalValue(value);
        return normalized == null ? 0 : normalized;
    }

    formatDiscount(discount) {
        return this.normalizeNumber(discount);
    }
}
